import {
  CREATE_CHAT_CHANNEL,
  CREATE_CHAT_CHANNEL_SUCCESS,
  CREATE_CHAT_CHANNEL_FAILURE,
  CREATE_GROUP,
  CREATE_GROUP_FAILURE,
  CREATE_GROUP_SUCCESS,
  MESSAGE_CHAT_CHANNEL,
  MESSAGE_CHAT_CHANNEL_FAILURE,
  MESSAGE_CHAT_CHANNEL_SUCCESS,
  UNREAD_MESSAGE_DOT,
  UNREAD_MESSAGE_DOT_FAILURE,
  UNREAD_MESSAGE_DOT_SUCCESS,
  DELETE_MESSAGE,
  DELETE_MESSAGE_FAILURE,
  DELETE_MESSAGE_SUCCESS,
  ADD_USERS_GROUP,
  ADD_USERS_GROUP_FAILURE,
  ADD_USERS_GROUP_SUCCESS,
  SHARE_MEDIA,
  SHARE_MEDIA_SUCCESS,
  SHARE_MEDIA_FAILURE,
  CREATE_GROUP_ADD_ID,
  CREATE_GROUP_ADD_ID_SUCCESS,
  CREATE_GROUP_ADD_ID_FAILURE,
  SELECTED_CHAT_USER,
  // Channels (broadcast groups)
  PROMOTE_CHANNEL_ADMINS,
  PROMOTE_CHANNEL_ADMINS_SUCCESS,
  PROMOTE_CHANNEL_ADMINS_FAILURE,
  DEMOTE_CHANNEL_ADMIN,
  DEMOTE_CHANNEL_ADMIN_SUCCESS,
  DEMOTE_CHANNEL_ADMIN_FAILURE,
  TRANSFER_CHANNEL_OWNERSHIP,
  TRANSFER_CHANNEL_OWNERSHIP_SUCCESS,
  TRANSFER_CHANNEL_OWNERSHIP_FAILURE,
  REMOVE_CHANNEL_MEMBER,
  REMOVE_CHANNEL_MEMBER_SUCCESS,
  REMOVE_CHANNEL_MEMBER_FAILURE,
  RETRACT_MESSAGE,
  RETRACT_MESSAGE_SUCCESS,
  RETRACT_MESSAGE_FAILURE,
  MESSAGE_DELETED_FOR_ALL,
  TOGGLE_SAVE_MESSAGE,
  TOGGLE_SAVE_MESSAGE_SUCCESS,
  TOGGLE_SAVE_MESSAGE_FAILURE,
  SAVED_MESSAGES_LIST,
  SAVED_MESSAGES_LIST_SUCCESS,
  SAVED_MESSAGES_LIST_FAILURE,
  MESSAGE_SAVE_STATE,
  CHANNEL_MEMBERS_PAGE,
  CHANNEL_MEMBERS_PAGE_SUCCESS,
  CHANNEL_MEMBERS_PAGE_FAILURE,
  CONVERSATION_TOUCHED,
  CHANNEL_READ,
  CHANNEL_READ_RECEIPT,
  SEND_MESSAGE,
  MESSAGE_SETTLED,
  CLEAR_CHAT_MESSAGES,
  GLOBAL_SEARCH_CHATS_GROUPS,
  GLOBAL_SEARCH_CHATS_GROUPS_SUCCESS,
  GLOBAL_SEARCH_CHATS_GROUPS_FAILURE,
  UPLOAD_CAHT_MEDIA,
  UPLOAD_CAHT_MEDIA_SUCCESS,
  UPLOAD_CAHT_MEDIA_FAILURE,
  DELETED_MESSAGE_NOW,
  REPORT_MSG,
  REPORT_MSG_SUCCESS,
  REPORT_MSG_FAILURE,
  // Calling
  START_CALL,
  START_CALL_SUCCESS,
  CALL_DETAILS,
  CALL_SESSION,
  ACTIVE_GROUP_CALL,
  START_CALL_FAILURE,
  JOIN_CALL,
  JOIN_CALL_SUCCESS,
  JOIN_CALL_FAILURE,
  RECENT_CALL_HISTORY,
  RECENT_CALL_HISTORY_SUCCESS,
  RECENT_CALL_HISTORY_FAILURE,
  MISSED_CALL_HISTORY,
  MISSED_CALL_HISTORY_SUCCESS,
  MISSED_CALL_HISTORY_FAILURE,
  USERS_DATA,
  USERS_DATA_SUCCESS,
  USERS_DATA_FAILURE,
  USER_PROFILE_DATA,
  USER_PROFILE_DATA_SUCCESS,
  USER_PROFILE_DATA_FAILURE,
  MULTIPLE_CALL_USERS_DATA,
  MULTIPLE_CALL_USERS_DATA_SUCCESS,
  MULTIPLE_CALL_USERS_DATA_FAILURE,
  MULTIPLE_CALLER,
  EMPTY_CALL_HISTORY,
  //Threads
  CREATE_THREADS,
  CREATE_THREADS_SUCCESS,
  CREATE_THREADS_FAILURE,
  JOIN_THREADS,
  JOIN_THREADS_SUCCESS,
  JOIN_THREADS_FAILURE,
  THREAD_DETAILS,
  THREAD_DETAILS_SUCCESS,
  THREAD_DETAILS_FAILURE,
  THREAD_LISTING,
  THREAD_LISTING_SUCCESS,
  THREAD_LISTING_FAILURE,
  UPLOAD_THREAD_MEDIA,
  UPLOAD_THREAD_MEDIA_SUCCESS,
  UPLOAD_THREAD_MEDIA_FAILURE,
  SEND_THREAD,
  CLEAR_CHAT_THREAD,
  THREAD_CHAT_CHANNEL,
  THREAD_CHAT_CHANNEL_SUCCESS,
  THREAD_CHAT_CHANNEL_FAILURE,
  DELETE_USER_PROFILE,
  DELETE_USER_PROFILE_SUCCESS,
  DELETE_USER_PROFILE_FAILURE,
  TOGGLE_NOTIFICATIONS,
  TOGGLE_NOTIFICATIONS_SUCCESS,
  TOGGLE_NOTIFICATIONS_FAILURE,
  NOTIFICATIONS_LISTS,
  NOTIFICATIONS_LISTS_SUCCESS,
  NOTIFICATIONS_LISTS_FAILURE,
  NOTIFICATIONS_UNREAD_COUNT,
  NOTIFICATIONS_UNREAD_COUNT_SUCCESS,
  NOTIFICATIONS_UNREAD_COUNT_FAILURE,
  MARK_NOTIFICATIONS_READ,
  MARK_NOTIFICATIONS_READ_SUCCESS,
  MARK_NOTIFICATIONS_READ_FAILURE,
  EDIT_USER_PROFILE,
  EDIT_USER_PROFILE_SUCCESS,
  EDIT_USER_PROFILE_FAILURE,
  DELETED_THREAD_MESSAGE_NOW,
  DELETE_THREAD,
  DELETE_THREAD_SUCCESS,
  DELETE_THREAD_FAILURE,
  DELETE_CHANNEL,
  DELETE_CHANNEL_SUCCESS,
  DELETE_CHANNEL_FAILURE,
  JOIN_GROUP,
  JOIN_GROUP_SUCCESS,
  JOIN_GROUP_FAILURE,
  LEAVE_GROUP,
  LEAVE_GROUP_SUCCESS,
  LEAVE_GROUP_FAILURE,
  GROUP_MEMBERS,
  GROUP_MEMBERS_SUCCESS,
  GROUP_MEMBERS_FAILURE,
  UPDATE_CREATE_GROUP,
  UPDATE_CREATE_GROUP_SUCCESS,
  UPDATE_CREATE_GROUP_FAILURE,
  MISSED_CALL_COUNT,
} from '../constants';

export default class MsgAction {
  static CreateChatChannel(payload, cb) {
    return {
      type: CREATE_CHAT_CHANNEL,
      payload,
      cb,
    };
  }
  static CreateChatChannelSuccess(payload) {
    return {
      type: CREATE_CHAT_CHANNEL_SUCCESS,
      payload,
    };
  }
  static CreateChatChannelFailure() {
    return {
      type: CREATE_CHAT_CHANNEL_FAILURE,
    };
  }

  static ShareMedia(payload, cb) {
    return {
      type: SHARE_MEDIA,
      payload,
      cb,
    };
  }
  static ShareMediaSuccess(payload) {
    return {
      type: SHARE_MEDIA_SUCCESS,
      payload,
    };
  }
  static ShareMediaFailure() {
    return {
      type: SHARE_MEDIA_FAILURE,
    };
  }

  static CreateGroup(payload, cb) {
    return {
      type: CREATE_GROUP,
      payload,
      cb,
    };
  }
  static CreateGroupSuccess(payload) {
    return {
      type: CREATE_GROUP_SUCCESS,
      payload,
    };
  }
  static CreateGroupFailure() {
    return {
      type: CREATE_GROUP_FAILURE,
    };
  }

  static CreateGroupAddId(payload, cb) {
    return {
      type: CREATE_GROUP_ADD_ID,
      payload,
      cb,
    };
  }
  static CreateGroupAddIdSuccess(payload) {
    return {
      type: CREATE_GROUP_ADD_ID_SUCCESS,
      payload,
    };
  }
  static CreateGroupAddIdFailure() {
    return {
      type: CREATE_GROUP_ADD_ID_FAILURE,
    };
  }
  static GroupMembers(payload, cb) {
    return {
      type: GROUP_MEMBERS,
      payload,
      cb,
    };
  }
  static GroupMembersSuccess(payload) {
    return {
      type: GROUP_MEMBERS_SUCCESS,
      payload,
    };
  }
  static GroupMembersFailure() {
    return {
      type: GROUP_MEMBERS_FAILURE,
    };
  }

  static UpdateCreateGroup(payload, cb) {
    return {
      type: UPDATE_CREATE_GROUP,
      payload,
      cb,
    };
  }
  static UpdateCreateGroupSuccess(payload) {
    return {
      type: UPDATE_CREATE_GROUP_SUCCESS,
      payload,
    };
  }
  static UpdateCreateGroupFailure() {
    return {
      type: UPDATE_CREATE_GROUP_FAILURE,
    };
  }

  static MessageChatChannel(payload, cb) {
    return {
      type: MESSAGE_CHAT_CHANNEL,
      payload,
      cb,
    };
  }
  static MessageChatChannelSuccess(payload) {
    return {
      type: MESSAGE_CHAT_CHANNEL_SUCCESS,
      payload,
    };
  }
  static MessageChatChannelFailure() {
    return {
      type: MESSAGE_CHAT_CHANNEL_FAILURE,
    };
  }

  static UploadChatMedia(payload, cb) {
    return {
      type: UPLOAD_CAHT_MEDIA,
      payload,
      cb,
    };
  }
  static UploadChatMediaSuccess(payload) {
    return {
      type: UPLOAD_CAHT_MEDIA_SUCCESS,
      payload,
    };
  }
  static UploadChatMediaFailure() {
    return {
      type: UPLOAD_CAHT_MEDIA_FAILURE,
    };
  }

  static UnreadMessageDot() {
    return {
      type: UNREAD_MESSAGE_DOT,
      // payload,
      // cb
    };
  }
  static UnreadMessageDotSuccess(payload) {
    return {
      type: UNREAD_MESSAGE_DOT_SUCCESS,
      payload,
    };
  }
  static UnreadMessageDotFailure() {
    return {
      type: UNREAD_MESSAGE_DOT_FAILURE,
    };
  }

  static DeleteMessage(payload, cb) {
    return {
      type: DELETE_MESSAGE,
      payload,
      cb,
    };
  }
  static DeleteMessageSuccess(payload) {
    return {
      type: DELETE_MESSAGE_SUCCESS,
      payload,
    };
  }
  static DeleteMessageFailure() {
    return {
      type: DELETE_MESSAGE_FAILURE,
    };
  }

  static AddUsersGroup(payload, cb) {
    return {
      type: ADD_USERS_GROUP,
      payload,
      cb,
    };
  }
  static AddUsersGroupSuccess(payload) {
    return {
      type: ADD_USERS_GROUP_SUCCESS,
      payload,
    };
  }
  static AddUsersGroupFailure() {
    return {
      type: ADD_USERS_GROUP_FAILURE,
    };
  }

  static GlobalSearchChatsGroups(payload, cb) {
    return {
      type: GLOBAL_SEARCH_CHATS_GROUPS,
      payload,
      cb,
    };
  }
  static GlobalSearchChatsGroupsSuccess(payload) {
    return {
      type: GLOBAL_SEARCH_CHATS_GROUPS_SUCCESS,
      payload,
    };
  }
  static GlobalSearchChatsGroupsFailure() {
    return {
      type: GLOBAL_SEARCH_CHATS_GROUPS_FAILURE,
    };
  }

  static SelectedChatUser(payload, cb) {
    return {
      type: SELECTED_CHAT_USER,
      payload,
      cb,
    };
  }

  static SendMsg(payload) {
    return {
      type: SEND_MESSAGE,
      payload,
    };
  }

  /**
   * Replace an optimistic message with the server's version of it.
   *
   * @param payload `{ temp_id, message, settled }`. `settled: false` leaves the
   *                row on screen marked as failed rather than removing it.
   */
  static MessageSettled(payload) {
    return {
      type: MESSAGE_SETTLED,
      payload,
    };
  }

  static ClearChatMsgs() {
    return {
      type: CLEAR_CHAT_MESSAGES,
    };
  }
  static EmptyCallHistory() {
    return {
      type: EMPTY_CALL_HISTORY,
    };
  }

  static DeleteMessageNow(payload) {
    return {
      type: DELETED_MESSAGE_NOW,
      payload,
    };
  }

  static DeleteThreadMessageNow(payload) {
    return {
      type: DELETED_THREAD_MESSAGE_NOW,
      payload,
    };
  }

  static missedCallCount(payload) {
    return {
      type: MISSED_CALL_COUNT,
      payload,
    };
  }
  static ReportMsg(payload, cb) {
    return {
      type: REPORT_MSG,
      payload,
      cb,
    };
  }
  static ReportMsgSuccess(payload) {
    return {
      type: REPORT_MSG_SUCCESS,
      payload,
    };
  }
  static ReportMsgFailure() {
    return {
      type: REPORT_MSG_FAILURE,
    };
  }

  //Calling
  static StartCall(payload, cb) {
    return {
      type: START_CALL,
      payload,
      cb,
    };
  }
  static StartCallSuccess(payload) {
    return {
      type: START_CALL_SUCCESS,
      payload,
    };
  }
  static StartCallFailure() {
    return {
      type: START_CALL_FAILURE,
    };
  }

  /**
   * Fetch one call. `cb` receives the record, or null if it could not be read —
   * the rejoin path treats "cannot tell" the same as "gone", so a caller must
   * handle null rather than assume a record.
   */
  static CallDetails(payload, cb) {
    return {
      type: CALL_DETAILS,
      payload,
      cb,
    };
  }

  /**
   * Resolve a call from its id alone — token, state and identity included.
   *
   * `cb` receives the session payload, or null if it could not be read. Used by a
   * tab that arrived at `/calling/:id` with nothing in memory: a reload, or a
   * notification click on a cold start.
   */
  static CallSession(payload, cb) {
    return {
      type: CALL_SESSION,
      payload,
      cb,
    };
  }

  /**
   * Is this group on a call right now? `cb` receives `{ call_id, type, answered_at }`
   * or null. Null is a real answer — "no call in progress" — not a failure.
   */
  static ActiveGroupCall(payload, cb) {
    return {
      type: ACTIVE_GROUP_CALL,
      payload,
      cb,
    };
  }

  static JoinCall(payload, cb) {
    return {
      type: JOIN_CALL,
      payload,
      cb,
    };
  }
  static JoinCallSuccess(payload) {
    return {
      type: JOIN_CALL_SUCCESS,
      payload,
    };
  }
  static JoinCallFailure() {
    return {
      type: JOIN_CALL_FAILURE,
    };
  }

  static MissedCallHistory(payload, cb) {
    return {
      type: MISSED_CALL_HISTORY,
      payload,
      cb,
    };
  }
  static MissedCallHistorySuccess(payload) {
    return {
      type: MISSED_CALL_HISTORY_SUCCESS,
      payload,
    };
  }
  static MissedCallHistoryFailure() {
    return {
      type: MISSED_CALL_HISTORY_FAILURE,
    };
  }

  static RecentCallHistory(payload, cb) {
    return {
      type: RECENT_CALL_HISTORY,
      payload,
      cb,
    };
  }
  static RecentCallHistorySuccess(payload) {
    return {
      type: RECENT_CALL_HISTORY_SUCCESS,
      payload,
    };
  }
  static RecentCallHistoryFailure() {
    return {
      type: RECENT_CALL_HISTORY_FAILURE,
    };
  }

  static UsersData(payload, cb) {
    return {
      type: USERS_DATA,
      payload,
      cb,
    };
  }
  static UsersDataSuccess(payload) {
    return {
      type: USERS_DATA_SUCCESS,
      payload,
    };
  }
  static UsersDataFailure() {
    return {
      type: USERS_DATA_FAILURE,
    };
  }

  static UserProfileData(payload, cb) {
    return {
      type: USER_PROFILE_DATA,
      payload,
      cb,
    };
  }
  static UserProfileDataSuccess(payload) {
    return {
      type: USER_PROFILE_DATA_SUCCESS,
      payload,
    };
  }
  static UserProfileDataFailure() {
    return {
      type: USER_PROFILE_DATA_FAILURE,
    };
  }

  static MultipleCallUsersData(payload, cb) {
    return {
      type: MULTIPLE_CALL_USERS_DATA,
      payload,
      cb,
    };
  }
  static MultipleCallUsersDataSuccess(payload) {
    return {
      type: MULTIPLE_CALL_USERS_DATA_SUCCESS,
      payload,
    };
  }
  static MultipleCallUsersDataFailure() {
    return {
      type: MULTIPLE_CALL_USERS_DATA_FAILURE,
    };
  }

  static MultipleCaller(payload, cb) {
    return {
      type: MULTIPLE_CALLER,
      payload,
      cb,
    };
  }

  // Threads
  static CreateThreads(payload, cb) {
    return {
      type: CREATE_THREADS,
      payload,
      cb,
    };
  }
  static CreateThreadsSuccess(payload) {
    return {
      type: CREATE_THREADS_SUCCESS,
      payload,
    };
  }
  static CreateThreadsFailure() {
    return {
      type: CREATE_THREADS_FAILURE,
    };
  }

  static JoinThreads(payload, cb) {
    return {
      type: JOIN_THREADS,
      payload,
      cb,
    };
  }
  static JoinThreadsSuccess(payload) {
    return {
      type: JOIN_THREADS_SUCCESS,
      payload,
    };
  }
  static JoinThreadsFailure() {
    return {
      type: JOIN_THREADS_FAILURE,
    };
  }

  static ThreadsDetails(payload, cb) {
    return {
      type: THREAD_DETAILS,
      payload,
      cb,
    };
  }
  static ThreadsDetailsSuccess(payload) {
    return {
      type: THREAD_DETAILS_SUCCESS,
      payload,
    };
  }
  static ThreadsDetailsFailure() {
    return {
      type: THREAD_DETAILS_FAILURE,
    };
  }

  static ThreadsListing(payload, cb) {
    return {
      type: THREAD_LISTING,
      payload,
      cb,
    };
  }
  static ThreadsListingSuccess(payload) {
    return {
      type: THREAD_LISTING_SUCCESS,
      payload,
    };
  }
  static ThreadsListingFailure() {
    return {
      type: THREAD_LISTING_FAILURE,
    };
  }

  static UploadThreadMedia(payload, cb) {
    return {
      type: UPLOAD_THREAD_MEDIA,
      payload,
      cb,
    };
  }
  static UploadThreadMediaSuccess(payload) {
    return {
      type: UPLOAD_THREAD_MEDIA_SUCCESS,
      payload,
    };
  }
  static UploadThreadMediaFailure() {
    return {
      type: UPLOAD_THREAD_MEDIA_FAILURE,
    };
  }

  static SendThreads(payload) {
    return {
      type: SEND_THREAD,
      payload,
    };
  }

  static ThreadChatChannel(payload, cb) {
    return {
      type: THREAD_CHAT_CHANNEL,
      payload,
      cb,
    };
  }
  static ThreadChatChannelSuccess(payload) {
    return {
      type: THREAD_CHAT_CHANNEL_SUCCESS,
      payload,
    };
  }
  static ThreadChatChannelFailure() {
    return {
      type: THREAD_CHAT_CHANNEL_FAILURE,
    };
  }

  static ClearChatThreads() {
    return {
      type: CLEAR_CHAT_THREAD,
    };
  }

  static DeleteUserProfile(payload, cb) {
    return {
      type: DELETE_USER_PROFILE,
      payload,
      cb,
    };
  }
  static DeleteUserProfileSuccess(payload) {
    return {
      type: DELETE_USER_PROFILE_SUCCESS,
      payload,
    };
  }
  static DeleteUserProfileFailure() {
    return {
      type: DELETE_USER_PROFILE_FAILURE,
    };
  }

  static ToggleNotifications(payload, cb, fcmToken) {
    return {
      type: TOGGLE_NOTIFICATIONS,
      payload,
      cb,
      fcmToken,
    };
  }
  static ToggleNotificationsSuccess(payload) {
    return {
      type: TOGGLE_NOTIFICATIONS_SUCCESS,
      payload,
    };
  }
  static ToggleNotificationsFailure() {
    return {
      type: TOGGLE_NOTIFICATIONS_FAILURE,
    };
  }

  /**
   * One page of the feed. `payload` is `{ offset, kind }` — `kind` is the tab
   * ('all' | 'messages' | 'mentions'), filtered by the server so a tab is never
   * empty just because the loaded page happened to hold none of its rows.
   */
  static NotificationsLists(payload, cb) {
    return {
      type: NOTIFICATIONS_LISTS,
      payload,
      cb,
    };
  }
  static NotificationsListsSuccess(payload) {
    return {
      type: NOTIFICATIONS_LISTS_SUCCESS,
      payload,
    };
  }
  static NotificationsListsFailure() {
    return {
      type: NOTIFICATIONS_LISTS_FAILURE,
    };
  }

  /** Unread totals per tab, for the badges beside the tab labels. */
  static NotificationsUnreadCount(cb) {
    return {
      type: NOTIFICATIONS_UNREAD_COUNT,
      cb,
    };
  }
  static NotificationsUnreadCountSuccess(payload) {
    return {
      type: NOTIFICATIONS_UNREAD_COUNT_SUCCESS,
      payload,
    };
  }
  static NotificationsUnreadCountFailure() {
    return {
      type: NOTIFICATIONS_UNREAD_COUNT_FAILURE,
    };
  }

  /**
   * Flip notifications to read. `payload` is an array of ids, or null/undefined
   * for "all of mine" — reading the feed no longer marks it read on the server,
   * so this is the only thing that clears unread state.
   */
  static MarkNotificationsRead(payload, cb) {
    return {
      type: MARK_NOTIFICATIONS_READ,
      payload,
      cb,
    };
  }
  static MarkNotificationsReadSuccess(payload) {
    return {
      type: MARK_NOTIFICATIONS_READ_SUCCESS,
      payload,
    };
  }
  static MarkNotificationsReadFailure() {
    return {
      type: MARK_NOTIFICATIONS_READ_FAILURE,
    };
  }

  static EditUserProfile(payload, cb) {
    return {
      type: EDIT_USER_PROFILE,
      payload,
      cb,
    };
  }
  static EditUserProfileSuccess(payload) {
    return {
      type: EDIT_USER_PROFILE_SUCCESS,
      payload,
    };
  }
  static EditUserProfileFailure() {
    return {
      type: EDIT_USER_PROFILE_FAILURE,
    };
  }

  static DeleteThread(payload, cb) {
    return {
      type: DELETE_THREAD,
      payload,
      cb,
    };
  }
  static DeleteThreadSuccess(payload) {
    return {
      type: DELETE_THREAD_SUCCESS,
      payload,
    };
  }
  static DeleteThreadFailure() {
    return {
      type: DELETE_THREAD_FAILURE,
    };
  }

  static JoinGroup(payload, cb) {
    return {
      type: JOIN_GROUP,
      payload,
      cb,
    };
  }
  static JoinGroupSuccess(payload) {
    return {
      type: JOIN_GROUP_SUCCESS,
      payload,
    };
  }
  static JoinGroupFailure() {
    return {
      type: JOIN_GROUP_FAILURE,
    };
  }

  static DeleteChannel(payload, cb) {
    return {
      type: DELETE_CHANNEL,
      payload,
      cb,
    };
  }
  static DeleteChannelSuccess(payload) {
    return {
      type: DELETE_CHANNEL_SUCCESS,
      payload,
    };
  }
  static DeleteChannelFailure() {
    return {
      type: DELETE_CHANNEL_FAILURE,
    };
  }

  static LeaveGroup(payload, cb) {
    return {
      type: LEAVE_GROUP,
      payload,
      cb,
    };
  }
  static LeaveGroupSuccess(payload) {
    return {
      type: LEAVE_GROUP_SUCCESS,
      payload,
    };
  }
  static LeaveGroupFailure() {
    return {
      type: LEAVE_GROUP_FAILURE,
    };
  }

  // ── Channel administration ─────────────────────────────────────────────────
  // payload: { channel_id, member_ids } / { channel_id, member_id }

  static PromoteChannelAdmins(payload, cb) {
    return { type: PROMOTE_CHANNEL_ADMINS, payload, cb };
  }
  static PromoteChannelAdminsSuccess(payload) {
    return { type: PROMOTE_CHANNEL_ADMINS_SUCCESS, payload };
  }
  static PromoteChannelAdminsFailure() {
    return { type: PROMOTE_CHANNEL_ADMINS_FAILURE };
  }

  static DemoteChannelAdmin(payload, cb) {
    return { type: DEMOTE_CHANNEL_ADMIN, payload, cb };
  }
  static DemoteChannelAdminSuccess(payload) {
    return { type: DEMOTE_CHANNEL_ADMIN_SUCCESS, payload };
  }
  static DemoteChannelAdminFailure() {
    return { type: DEMOTE_CHANNEL_ADMIN_FAILURE };
  }

  static TransferChannelOwnership(payload, cb) {
    return { type: TRANSFER_CHANNEL_OWNERSHIP, payload, cb };
  }
  static TransferChannelOwnershipSuccess(payload) {
    return { type: TRANSFER_CHANNEL_OWNERSHIP_SUCCESS, payload };
  }
  static TransferChannelOwnershipFailure() {
    return { type: TRANSFER_CHANNEL_OWNERSHIP_FAILURE };
  }

  static RemoveChannelMember(payload, cb) {
    return { type: REMOVE_CHANNEL_MEMBER, payload, cb };
  }
  static RemoveChannelMemberSuccess(payload) {
    return { type: REMOVE_CHANNEL_MEMBER_SUCCESS, payload };
  }
  static RemoveChannelMemberFailure() {
    return { type: REMOVE_CHANNEL_MEMBER_FAILURE };
  }

  // payload: { message_id, deleted_by_id }
  static RetractMessage(payload, cb) {
    return { type: RETRACT_MESSAGE, payload, cb };
  }
  static RetractMessageSuccess(payload) {
    return { type: RETRACT_MESSAGE_SUCCESS, payload };
  }
  static RetractMessageFailure() {
    return { type: RETRACT_MESSAGE_FAILURE };
  }

  /**
   * Mark a message as deleted for everyone in the local stream.
   * Dispatched both by the retracting admin's own saga and by the
   * `message:deleted` socket listener, so it must be idempotent — it is: setting
   * `deleted_by_id` twice is the same as setting it once.
   *
   * payload: { message_id, deleted_by_id }
   */
  static MessageDeletedForAll(payload) {
    return { type: MESSAGE_DELETED_FOR_ALL, payload };
  }

  // ─── saved messages (bookmarks) ────────────────────────────────────────────

  /**
   * Star or unstar a message. payload: { message_id, is_saved, note? }
   *
   * `is_saved` is the DESIRED state, not the current one, so the saga does not have
   * to re-read the stream to work out which way the toggle went.
   */
  static ToggleSaveMessage(payload, cb) {
    return { type: TOGGLE_SAVE_MESSAGE, payload, cb };
  }
  static ToggleSaveMessageSuccess(payload) {
    return { type: TOGGLE_SAVE_MESSAGE_SUCCESS, payload };
  }
  /** payload: { message_id, is_saved } — the state to roll BACK to. */
  static ToggleSaveMessageFailure(payload) {
    return { type: TOGGLE_SAVE_MESSAGE_FAILURE, payload };
  }

  /** payload: { limit?, offset?, search? } — offset 0 replaces, higher appends. */
  static SavedMessagesList(payload, cb) {
    return { type: SAVED_MESSAGES_LIST, payload, cb };
  }
  static SavedMessagesListSuccess(payload) {
    return { type: SAVED_MESSAGES_LIST_SUCCESS, payload };
  }
  static SavedMessagesListFailure() {
    return { type: SAVED_MESSAGES_LIST_FAILURE };
  }

  /** Local-only star patch. payload: { message_id, is_saved } */
  static MessageSaveState(payload) {
    return { type: MESSAGE_SAVE_STATE, payload };
  }

  /** payload: { channel_id, limit?, offset? } — offset 0 replaces, higher appends. */
  static ChannelMembersPage(payload, cb) {
    return { type: CHANNEL_MEMBERS_PAGE, payload, cb };
  }
  static ChannelMembersPageSuccess(payload) {
    return { type: CHANNEL_MEMBERS_PAGE_SUCCESS, payload };
  }
  static ChannelMembersPageFailure() {
    return { type: CHANNEL_MEMBERS_PAGE_FAILURE };
  }

  /**
   * Local-only patch for an inbound `message:alert`.
   *
   * payload: { channel_id, message, sender_id, is_open } — `is_open` says whether the
   * reader is looking at that conversation right now, which decides whether the unread
   * badge moves.
   */
  static ConversationTouched(payload) {
    return { type: CONVERSATION_TOUCHED, payload };
  }

  /**
   * Local-only patch for a read this client just performed.
   *
   * payload: `{ channel_id, others_read_at }` — the ack of `message:read`. Zeroes that
   * one row's badge where the list already holds it, instead of the unfiltered
   * `GlobalSearchChatsGroups()` refetch this replaces: that returned page one with no
   * search term, so opening a conversation cleared the sidebar's active search and threw
   * away every page the reader had scrolled through — and it ran again on every inbound
   * message for as long as the conversation stayed open.
   */
  static ChannelRead(payload) {
    return { type: CHANNEL_READ, payload };
  }

  /**
   * A `message:read:alert` from another member.
   *
   * payload: `{ channel_id, others_read_at }`. Moves the read-by-everyone timestamp only —
   * deliberately NOT `ChannelRead`, which also zeroes the badge: somebody else opening the
   * conversation says nothing about whether this reader has seen anything in it.
   */
  static ChannelReadReceipt(payload) {
    return { type: CHANNEL_READ_RECEIPT, payload };
  }
}
